<script>
    import { fade } from 'svelte/transition';
    import {link , push} from 'svelte-spa-router'
    import fetchData from '../api.js';
    import UserStore from '../stores/user';
    import { validateFields }  from '../base/validation.js';
    import { _ } from "svelte-i18n";
    import { onMount } from 'svelte';
    import Header from '../components/Header.svelte'; 
    import TopInfo from '../components/TopInfo.svelte';  
    import Preloader from '../components/Preloader.svelte'; 
    import ToolTip from '../components/ToolTip.svelte'; 

    let isLoading = false;
    let settings_page = "0";
    let popup = false;

    let erp_settings = {};
    let settings = {
        mapping : {},
        platform : {
            datalogics_shipping_order_status:[],
            datalogics_shipping_options:[],
            datalogics_shipping_options_enabled : 0,
            myaccount_tracking : 1,
            myaccount_tracking_email:0,
            send_status_emails : 0,
            skip_virtual_products : "0"
        },
        shipment_type : [],
        limit_by_tags : '',
        limit_by_sku : '',  
        limit_by_sku_exclude : '',
        shipping_push_supplier_name  : '',
        shipping_push_supplier_phone  : '',
        shipping_push_supplier_email : '',
        shipping_mark_fullfiled :'1',
        fullfiled_customer_notification : '1',
        shipping_push_products_in_comments:'0',
        shipping_push_notes_in_comments : '0',
        shipping_hide_origin_details_on_label : '0',
        shipping_label_paper_type : 'printer',
        shipping_label_a4_labels_per_row : '2',
        shipping_packages_by_quantity : '0',
        enable_scanning_products : "0",
        limit_results  : '',
        shipping_pull_platform : shipping_pull_platform,
        shipping_auto_create_delivery : "0",
        shipping_auto_create_delivery_order_id : "",
        add_shipment_delay_days : "",
        exclude_pos : "1",
        auto_create_limit_by_shipping_method : "",
        auto_create_block_by_shipping_method : "",
        show_barcodes : 0,
        auto_pickup_text : '',
        auto_pickup : "0",
        automatic_print_after_creation_of_tracking : "0",
        create_shipment_after_scan : "0",
        printer : '',
        creation_shipment_change_new_status : "wc-completed",
        creation_shipment_trigger_new_status : "",
        datalogics_auto_address : "0"
    }

    if (shipping_push_supplier=="66") {
        erp_settings.platform2 = shipping_push_supplier;
        erp_settings.platform2_username = '';
        erp_settings.platform2_password = '';
        erp_settings.platform1 = shipping_pull_platform;
        erp_settings.orders_sync = 1;
        erp_settings.orders_last_order = settings.shipping_auto_create_delivery_order_id
    }    

    onMount(async() => {

        console.log('UserStore',$UserStore)

        if (!$UserStore || !$UserStore.data){
            push('/login');
            return;
        }
        

        if ($UserStore?.settings?.erp_settings) {
            erp_settings = $UserStore?.settings?.erp_settings;
            console.log('erp_settingserp_settingserp_settings',erp_settings)
        }

        if (!Array.isArray(erp_settings.coupon_sku_mappings)) {
            erp_settings = {
                ...erp_settings,
                coupon_sku_mappings: []
            };
        }

        let temp_settings = $UserStore.settings.shipping_settings;        

        if (shipping_push_supplier=="66") {
            if ($UserStore.settings.erp_settings && $UserStore.settings.erp_settings.platform2_username) {
                erp_settings.platform2_username = $UserStore.settings.erp_settings.platform2_username;
            }
            if ($UserStore.settings.erp_settings && $UserStore.settings.erp_settings.platform2_password) {
                erp_settings.platform2_password = $UserStore.settings.erp_settings.platform2_password;
            }
        }  

        for(var key in temp_settings) {
            settings[key] = temp_settings[key]
        }

        if (
            !settings.platform.datalogics_shipping_options ||
            !Array.isArray(settings.platform.datalogics_shipping_options)
        ) {
            settings.platform.datalogics_shipping_options = [];
        }

        if (
            !settings.platform.datalogics_shipping_order_status ||
            !Array.isArray(settings.platform.datalogics_shipping_order_status)
        ) {
            settings.platform.datalogics_shipping_order_status = [];
        }


        let type = typeof settings.shipping_method ;
        if (settings.shipping_method && settings.shipping_method.length) {
            let shipping_methods = settings.shipping_method;
            
            if (settings.shipping_push_supplier_name === '' && shipping_methods[0].shipping_push_supplier_name!='') {
                settings.shipping_push_supplier_name = shipping_methods[0].shipping_push_supplier_name;
            }

            if (settings.shipping_push_supplier_phone === '' && shipping_methods[0].shipping_push_supplier_phone!='') {
                settings.shipping_push_supplier_phone = shipping_methods[0].shipping_push_supplier_phone;
            }

            if (settings.shipping_push_supplier_email === '' && shipping_methods[0].shipping_push_supplier_email!='') {
                settings.shipping_push_supplier_email = shipping_methods[0].shipping_push_supplier_email;
            }

        } 

        
        if (settings?.shipping_push_supplier_name==''|| settings?.shipping_push_supplier_phone=='' || 
        settings?.shipping_push_supplier_name == undefined || settings?.shipping_push_supplier_phone == undefined
        ) {
            popup = true;
        }  


               
       
    })


    const handleSubmit = async() => {


        if (!validateFields(settings,2)) {
            
            alert('יש מלא את כל השדות חובה')
            return;
        }

        isLoading = true;

        let postData = {};

        postData.action = 'w_update_shipping_methods';
        postData.token = $UserStore.data
        postData.datalogics_shipping_settings = settings;

        if ($UserStore?.erp==1) {
            postData.datalogics_erp = erp_settings
        }
        

        if (shipping_push_supplier=="66") {
            erp_settings.orders_last_order = settings.shipping_auto_create_delivery_order_id
            postData.datalogics_erp = erp_settings;
        }

        let response = await fetchData(postData);
        if (response.data) {

            $UserStore.settings = response.data;
            localStorage.setItem('user',JSON.stringify($UserStore))            

            alert('הנתונים נשמרו בהצלחה')

        }



        isLoading = false;


    }

    console.log('erp_platforms',erp_platforms)



    function addShipmentTypeTag() {
        settings.shipment_type = [...settings.shipment_type, { tag_name: '', tag_value: '1' }];
    }

    function removeShipmentTypeTag(index) {
        settings.shipment_type = settings.shipment_type.filter((_, i) => i !== index);
    }

    function addCouponSkuMapping() {
        if (!Array.isArray(erp_settings.coupon_sku_mappings)) {
            erp_settings.coupon_sku_mappings = [];
        }

        erp_settings = {
            ...erp_settings,
            coupon_sku_mappings: [
                ...erp_settings.coupon_sku_mappings,
                { coupon_code: '', product_sku: '' }
            ]
        };
    }

    
</script>

<div class="page-container" transition:fade={{ delay: 250, duration: 300 }}>
    <Preloader {isLoading}/>
    <Header />
    <div class="page">    
        <TopInfo/>
        <div class="shipment">

            {#if popup}
            <div class="fixed top-0 bottom-0 left-0 right-0 m-auto z-50 flex flex-col items-center justify-center bg-black bg-opacity-50">
                <div class="bg-white shadow-lg p-4 relative">
                    <div class="absolute top-[10px] left-[10px] cursor-pointer text-[20px]" on:click={()=> popup = false }>X</div>
                    <h1 class="text-[20px] font-bold mt-[20px]">{$_('settings.popup_welcome_title')}</h1>
                    <div>{$_('settings.popup_welcome_text')}</div>
                </div>
            </div>
            {/if}

            <h1 class="text-[20px] font-bold">{$_('settings.title')}</h1>        
            <div class="shipment-flex mb-[50px]">
                <div class="shipment_origin">
                    <div class="input_box">    
                        <div class="input_con">
                            <label><i class="fa-solid fa-asterisk"></i> {$_('settings.label_name')}</label>
                            <input type="text" bind:value={settings.shipping_push_supplier_name} class:input_empty_error={settings.shipping_push_supplier_name === ''}>
                        </div>
                    </div>     
                    <div class="input_box">
                        <div class="input_con">
                            <label><i class="fa-solid fa-asterisk"></i> {$_('settings.phone')}</label>
                            <input type="text" bind:value={settings.shipping_push_supplier_phone} class:input_empty_error={settings.shipping_push_supplier_phone === ''}>
                        </div>             
                        <div class="input_con">
                            <label>{$_('shipment.email')}</label>
                            <input type="text" bind:value={settings.shipping_push_supplier_email} class="ltr">
                        </div>
                    </div>


                    {#if $UserStore.erp?.toString() === "1"}
                        <div class="input_box mb-2">
                            <div class="input_con radio">
                                <input id="pudo_enabled2" type="radio" name="settings_page" value="0" bind:group={settings_page}>
                                <label for="pudo_enabled2" class="rounded-tr-0 rounded-br-0">{$_('settings.shipping_settings')}</label>

                                <input id="pudo_enabled1" type="radio" name="settings_page" value="1" bind:group={settings_page}>
                                <label for="pudo_enabled1" class="rounded-tl-0 rounded-bl-0">{$_('settings.erp_settings')}</label>
                            </div>                            
                        </div>
                    {/if}


                    <h2 class="text-[16px] font-bold mt-5">{$_('settings.shipping_settings')}</h2>
                    

                    {#if settings_page == "0"}
                        <div class="input_box">
                            <div class="input_con">   
                                {#if shippingo==2}                             
                                <label>{$_('settings.change_status_on_creation')}</label>
                                {:else}
                                <label>{$_('settings.shipping_mark_fullfiled')}</label>
                                {/if}
                                <select bind:value={settings.shipping_mark_fullfiled}>
                                    <option value="1">{$_('settings.yes_by_creating_shipment')}</option>
                                    <option value="2">{$_('settings.yes_by_trigger')}</option>
                                    <option value="0">{$_('settings.no')}</option>
                                </select>
                            </div> 
                            {#if settings.shipping_mark_fullfiled==2}
                            <div class="input_con">
                                <label>{$_('settings.shipping_change_status_by_status_trigger')}</label>
                                <input type="text" bind:value={settings.creation_shipment_trigger_new_status}/>
                            </div>
                            {/if}
                            {#if shippingo!="2"}
                            <div class="input_con">
                                <label>{$_('settings.fullfiled_customer_notification')}</label>
                                <select bind:value={settings.fullfiled_customer_notification}>
                                    <option value="1">{$_('settings.yes')}</option>
                                    <option value="0">{$_('settings.no')}</option>
                                </select>
                            </div>
                            {:else}     
                                {#if settings.shipping_mark_fullfiled==1 || settings.shipping_mark_fullfiled==2}
                                <div class="input_con">
                                    <label>{$_('settings.shipping_change_status')}</label>
                                    {#if settings?.platform?.available_statues}
                                    <select bind:value={settings.creation_shipment_change_new_status}>
                                        {#each settings.platform.available_statues as status}
                                            {#each Object.entries(status) as [key, value]}
                                                <option value={key}>{value}</option>
                                            {/each}  
                                        {/each}                      
                                    </select>
                                    {/if}
                                </div>                                                                
                                {/if}
                            {/if}
                        </div>


                        
                        {#if shippingo=="2"}                 
                        <div class="input_box">
                            <div class="input_con">
                                <label>{$_('settings.shipping_options_enabled')}</label>
                                <select bind:value={settings.platform.datalogics_shipping_options_enabled}>
                                    <option value="0">{$_('settings.no')}</option>
                                    <option value="1">{$_('settings.yes')}</option>                                
                                </select>
                            </div>
                            {#if settings.platform.datalogics_shipping_options_enabled == "1"}
                            <div class="input_con">
                                <label>{$_('settings.shipping_options')}</label>
                                {#if settings?.platform?.available_shipping_options}
                                <select bind:value={settings.platform.datalogics_shipping_options} multiple>
                                    {#each settings.platform.available_shipping_options as option}  
                                        {#if typeof option === 'object' && option !== null}                                      
                                            {#each Object.entries(option) as [key, value]}
                                                <option value={key}>{value}</option>                           
                                            {/each} 
                                        {/if}
                                    {/each}                            
                                </select>
                                {/if}
                            </div>
                            {/if}                            
                        </div>
                        <div class="input_con">
                                <label>{$_('settings.skip_virtual_products')}</label>
                                <select bind:value={settings.platform.skip_virtual_products}>
                                    <option value="0">{$_('settings.no')}</option>
                                    <option value="1">{$_('settings.yes')}</option>                                
                                </select>
                            </div>
                        {/if}

                        <h2 class="text-[16px] font-bold mt-5">{$_('settings.shipping_auto_title')}</h2>  
                        <div class="input_box">

                            <div class="input_con">
                                <label>{$_('settings.auto_delivery')}</label>
                                <select bind:value={settings.shipping_auto_create_delivery}>
                                    <option value="0">{$_('settings.no')}</option>
                                    <option value="1">{$_('settings.yes')}</option>                                    
                                </select>
                            </div> 
                            {#if settings.shipping_auto_create_delivery==1}
                                <div class="input_con">
                                    <label><i class="fa-solid fa-asterisk"></i>{$_('settings.auto_delivery_from_id')}</label>
                                    <input type="text" bind:value={settings.shipping_auto_create_delivery_order_id}>
                                </div>
                                {#if shippingo=="2"}
                                <div class="input_con">
                                    <label><i class="fa-solid fa-asterisk"></i>{$_('settings.shipping_status')}</label>
                                    {#if settings?.platform?.available_statues}
                                    <select bind:value={settings.platform.datalogics_shipping_order_status} multiple>
                                        {#each settings.platform.available_statues as status}
                                            {#each Object.entries(status) as [key, value]}
                                                <option value={key}>{value}</option>
                                            {/each}  
                                        {/each}                      
                                    </select>
                                    {/if}
                                </div>
                                {/if}
                                <div class="input_con">
                                    <label><i class="fa-solid fa-asterisk"></i>{$_('settings.add_shipment_delay_days')}</label>
                                    <input type="text" bind:value={settings.add_shipment_delay_days}>
                                </div>                                
                            {/if}

                        </div>


                        

                        {#if shippingo=="2"}
                        <h2 class="text-[16px] font-bold mt-5">{$_('settings.shipping_customer_settings')}</h2>
                        <div class="input_box">
                            <div class="input_con">
                                <label>{$_('settings.myaccount_tracking')}</label>
                                <select bind:value={settings.platform.myaccount_tracking}>
                                    <option value="0">{$_('settings.no')}</option>
                                    <option value="1">{$_('settings.yes')}</option>                                
                                </select>
                                {#if shippingo=="2"}
                                <span class="tooltip">
                                    {$_('settings.short_code')} [datalogics_shipping_tracker]
                                    <!--<ToolTip text={$_('locations.explain_name')}></ToolTip>-->
                                </span>
                                {/if}
                            </div>
                            <div class="input_con">
                                <label>{$_('settings.myaccount_tracking_email')}</label>
                                <select bind:value={settings.platform.myaccount_tracking_email}>
                                    <option value="0">{$_('settings.no')}</option>
                                    <option value="1">{$_('settings.yes')}</option>                                
                                </select>
                            </div>
                            <div class="input_con">
                                <label>{$_('settings.send_status_emails')}</label>
                                <select bind:value={settings.platform.send_status_emails}>
                                    <option value="0">{$_('settings.no')}</option>
                                    <option value="1">{$_('settings.yes')}</option>                                
                                </select>
                            </div>
                            <!-- <div class="input_con">
                                <label>{$_('settings.myaccount_tracking_email_link')}</label>
                                <select bind:value={settings.platform.myaccount_tracking_email_link}>
                                    <option value="0">{$_('settings.no')}</option>
                                    <option value="1">{$_('settings.yes')}</option>                                
                                </select>
                            </div> -->
                        </div>

                        {/if}

                        {#if shippingo=="2"}
                        <h2 class="text-[16px] font-bold mt-5">{$_('settings.auto_complete_title')}</h2>
                        <div class="input_box">
                            <div class="input_con">
                                <label>{$_('settings.auto_complete_city_street')}</label>
                                <select bind:value={settings.datalogics_auto_address}>
                                    <option value="1">{$_('settings.yes')}</option>
                                    <option value="0">{$_('settings.no')}</option>
                                </select>
                            </div>   
                        </div>
                        {/if}

                        <h2 class="text-[16px] font-bold mt-5">{$_('settings.label_settings')}</h2>
                        <div class="input_box">
                            <div class="input_con">
                                <label>{$_('settings.shipping_push_products_in_comments')}</label>
                                <select bind:value={settings.shipping_push_products_in_comments}>
                                    <option value="0">{$_('settings.no')}</option>
                                    <option value="1">{$_('settings.yes')}</option>                                
                                </select>
                            </div>
                            <div class="input_con">
                                <label>{$_('settings.shipping_push_notes_in_comments')}</label>
                                <select bind:value={settings.shipping_push_notes_in_comments}>
                                    <option value="0">{$_('settings.no')}</option>
                                    <option value="1">{$_('settings.yes')}</option>                                
                                </select>
                            </div>                            
                            <div class="input_con">
                                <label>{$_('settings.shipping_packages_by_quantity')}</label>
                                <select bind:value={settings.shipping_packages_by_quantity}>
                                    <option value="0">{$_('settings.no')}</option>
                                    <option value="1">{$_('settings.yes')}</option>                                
                                </select>
                            </div>
                            <div class="input_con">
                                <label>{$_('settings.shipping_hide_origin_details_on_label')}</label>
                                <select bind:value={settings.shipping_hide_origin_details_on_label}>
                                    <option value="0">{$_('settings.no')}</option>
                                    <option value="1">{$_('settings.yes')}</option>
                                </select>
                            </div>
                        </div>
                        <div class="input_box">
                            <div class="input_con">
                                <label>{$_('settings.shipping_label_paper_type')}</label>
                                <select bind:value={settings.shipping_label_paper_type}>
                                    <option value="printer">{$_('settings.shipping_label_paper_type_printer')}</option>
                                    <option value="a4">{$_('settings.shipping_label_paper_type_a4')}</option>
                                </select>
                            </div>
                            {#if settings.shipping_label_paper_type === "a4"}
                            <div class="input_con">
                                <label>{$_('settings.shipping_label_a4_labels_per_row')}</label>
                                <select bind:value={settings.shipping_label_a4_labels_per_row}>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                </select>
                            </div>
                            {/if}
                        </div>

                        <h2 class="text-[16px] font-bold mt-5">{$_('settings.shipping_limitations')}</h2>

                        <div class="input_box">
                            <div class="input_con">
                                <label>{$_('settings.exclude_pos')}</label>
                                <select bind:value={settings.exclude_pos}>
                                    <option value="1">{$_('settings.yes')}</option>
                                    <option value="0">{$_('settings.no')}</option>
                                </select>
                            </div>   
                        </div>

                        <div class="input_box">
                            <div class="input_con">
                                <label>{$_('settings.auto_create_limit_by_shipping_method')}</label>
                                <input type="text" bind:value={settings.auto_create_limit_by_shipping_method}>
                            </div>
                        </div>

                        <div class="input_box">
                            <div class="input_con">
                                <label>{$_('settings.auto_create_block_by_shipping_method')}</label>
                                <input type="text" bind:value={settings.auto_create_block_by_shipping_method}>
                            </div>
                        </div>

                        <div class="input_box">

                            <div class="input_con">
                                <label>{$_('settings.limit_by_sku')}</label>
                                <input type="text" bind:value={settings.limit_by_sku}>
                            </div>

                        </div>

                        <div class="input_box">

                            <div class="input_con">
                                <label>{$_('settings.limit_by_sku_exclude')}</label>
                                <input type="text" bind:value={settings.limit_by_sku_exclude}>
                            </div>
                            
                        </div>

                        <div class="input_box">

                            <div class="input_con">
                                <label>{$_('settings.limit_by_tags')}</label>
                                <input type="text" bind:value={settings.limit_by_tags}>
                            </div>

                        </div>

                        <div class="border border-[#ababab] p-2 rounded-[7px] my-[10px]">
                            <label class="text-gray-700">{$_('settings.auto_shipment_type_by_tag')}</label>                        
                            {#each settings.shipment_type as tag, index}                        
                            <div class="input_box">                            
                                <div class="input_con flex flex-row gap-2">                                
                                    <div class="input_box flex flex-col">
                                    <input 
                                            type="text" 
                                            bind:value={tag.tag_name}
                                            class="border rounded-md px-3 py-2"
                                        >
                                    </div>
                                    <div class="input_box">
                                        <select 
                                            bind:value={tag.tag_value}
                                            class="border rounded-md px-3 py-2"
                                        >
                                            <option value="1"> {$_('shipment.delivery')}</option>
                                            <option value="2"> {$_('shipment.double_govina')}</option>
                                            <option value="3"> {$_('shipment.pickup')}</option>
                                        </select>
                                    </div>
                                    {#if settings.shipment_type.length > 0}
                                    <div class="input_box">
                                        <button 
                                            type="button" 
                                            on:click={() => removeShipmentTypeTag(index)}
                                            class="bg-red-500 text-white px-3 py-1 rounded-md hover:bg-red-600 transition-colors"
                                        >
                                            {$_('companies.delete')}
                                        </button>
                                    </div>
                                    {/if}
                                </div>
                            </div>
                            {/each} 
                            <div class="input_box">                      
                                <button 
                                    type="button" 
                                    on:click={addShipmentTypeTag}
                                    class="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition-colors"
                                >
                                {$_('companies.add')}
                                </button>
                            </div>
                        </div>

                        

                        {#if shippingo=="0"}

                        <h2>{$_('settings.settings_options')}</h2>

                        <div class="input_box">
                            <div class="input_con">
                                <label>{$_('settings.enable_scanning_products')}</label>
                                <select bind:value={settings.enable_scanning_products}>
                                    <option value="0">{$_('settings.no')}</option>
                                    <option value="1">{$_('settings.yes')}</option>                                
                                </select>
                            </div>
                            <div class="input_con">
                                <label>{$_('settings.show_barcodes_in_print')}</label>
                                <select bind:value={settings.show_barcodes}>
                                    <option value="0">{$_('settings.no')}</option>
                                    <option value="1">{$_('settings.yes')}</option>                                
                                </select>
                            </div> 
                            <div class="input_con">
                                <label>{$_('settings.automatic_print_after_creation_of_tracking')}</label>
                                <select bind:value={settings.automatic_print_after_creation_of_tracking}>
                                    <option value="0">{$_('settings.no')}</option>
                                    <option value="1">{$_('settings.yes')}</option>                                
                                </select>
                            </div>
                            <div class="input_con">
                                <label>{$_('settings.create_shipment_after_scan')}</label>
                                <select bind:value={settings.create_shipment_after_scan}>
                                    <option value="0">{$_('settings.no')}</option>
                                    <option value="1">{$_('settings.yes')}</option>                                
                                </select>
                            </div> 
                            {#if printers.length}
                            <div class="input_con">
                                <label for="printer-select">Select Printer:</label>
                                <select id="printer-select" bind:value={settings.printer}>
                                    {#each printers as printer}
                                    <option value={printer}>{printer}</option>
                                    {/each}
                                </select>
                            </div>
                            {/if}
                        </div>


                        {/if} 
   
                    {:else}

                    
                        <h2 class="mt-5 font-bold">{$_('settings.source_erp')}</h2>
                        <div class="input_box">
                            <select bind:value={erp_settings.platform1}>
                                {#each Object.keys(erp_platforms) as key}
                                    <option value={key}>{erp_platforms[key].name}</option>
                                {/each}
                            </select>
                        </div>
                        <div class="input_box">
                            <div class="input_con">
                                <label>{$_('settings.url')}</label>
                                <input type="text" bind:value={erp_settings.platform1_url}>
                            </div>
                        </div>
                        <div class="input_box">
                            <div class="input_con">
                                <label>{$_('settings.username')}</label>
                                <input type="text" bind:value={erp_settings.platform1_key}>
                            </div>
                            <div class="input_con">
                                <label>{$_('settings.password')}</label>
                                <input type="text" bind:value={erp_settings.platform1_password}>
                            </div>
                        </div>
                        <h2 class="mt-5 font-bold">{$_('settings.destination_erp')}</h2>
                        <div class="input_box">
                            <select bind:value={erp_settings.platform2}>
                                {#each Object.keys(erp_platforms) as key}
                                    <option value={key}>{erp_platforms[key].name}</option>
                                {/each}
                            </select>
                        </div>
                        <div class="input_box">
                            <div class="input_con">
                                <label>{$_('settings.url')}</label>
                                <input type="text" bind:value={erp_settings.platform2_url}>
                            </div>
                        </div>
                        <div class="input_box">
                            <div class="input_con">
                                <label>{$_('settings.username')}</label>
                                <input type="text" bind:value={erp_settings.platform2_username}>
                            </div>
                            <div class="input_con">
                                <label>{$_('settings.password')}</label>
                                <input type="text" bind:value={erp_settings.platform2_password}>
                            </div>
                        </div>
                        <h2 class="mt-5 font-bold">{$_('settings.inventory_settings')}</h2>
                        <div class="input_box">
                            <div class="input_con">
                                <label>{$_('settings.sync_inventory')}</label>
                                <select bind:value={erp_settings.stock_sync}>
                                    <option value="0">{$_('settings.no')}</option>
                                    <option value="1">{$_('settings.yes')}</option>
                                </select>
                            </div>
                            <div class="input_con">
                                <label>{$_('settings.stock_min')}</label>
                                <input type="text" bind:value={erp_settings.stock_min}>
                            </div>
                            <div class="input_con">
                                <label>{$_('settings.stock_stores_include')}</label>
                                <input type="text" dir="ltr" bind:value={erp_settings.stock_stores_include}>
                            </div>
                        </div>
                        <h2 class="mt-5 font-bold">{$_('settings.orders_settings')}</h2>
                        <div class="input_box">
                            <div class="input_con">
                                <label>{$_('settings.sync_orders')}</label>
                                <select bind:value={erp_settings.orders_sync}>
                                    <option value="0">{$_('settings.no')}</option>
                                    <option value="1">{$_('settings.yes')}</option>
                                </select>
                            </div>
                            <div class="input_con">
                                <label>{$_('settings.orders_doc_type')}</label>
                                <select bind:value={erp_settings.orders_doc_type}>
                                    <option value="0">{$_('settings.invoice_receipt')}</option>
                                    <option value="1">{$_('settings.order')}</option>
                                </select>
                            </div>
                            <div class="input_con">
                                <label>{$_('settings.orders_last_order')}</label>
                                <input type="text" bind:value={erp_settings.orders_last_order}>
                            </div>
                            <div class="input_con">
                                <label>{$_('settings.orders_push_status')}</label>
                                <input type="text" bind:value={erp_settings.orders_push_status}>
                            </div>
                        </div>

                        <h2 class="mt-5 font-bold">{$_('settings.coupon_sku_mappings_title')}</h2>
                        <div class="border border-[#ababab] p-2 rounded-[7px] my-[10px]">
                            {#each erp_settings.coupon_sku_mappings as mapping}
                                <div class="input_box">
                                    <div class="input_con">
                                        <label>{$_('settings.coupon_code')}</label>
                                        <input type="text" bind:value={mapping.coupon_code} class="ltr">
                                    </div>
                                    <div class="input_con">
                                        <label>{$_('settings.product_sku')}</label>
                                        <input type="text" bind:value={mapping.product_sku} class="ltr">
                                    </div>
                                </div>
                            {/each}
                            <div class="input_box">
                                <button 
                                    type="button" 
                                    on:click={addCouponSkuMapping}
                                    class="bg-blue-500 text-white px-4 py-2 rounded-md hover:bg-blue-600 transition-colors"
                                >
                                    {$_('settings.coupon_sku_add')}
                                </button>
                            </div>
                        </div>
                    
                    {/if}


                    {#if shippingo=="2"}

                    <h2 class="mt-5 font-bold">{$_('settings.fields_mapping')}</h2>
                    <div class="desciption">{$_('settings.fields_mapping_desc')}</div>
                    <div class="input_box">
                        <!-- Existing settings inputs here... -->

                        <div class="input_con">
                            <label>{$_('settings.mapping_street')}</label>
                            <input type="text" bind:value={settings.mapping.street} class="ltr">
                        </div>
                        <div class="input_con">
                            <label>{$_('settings.mapping_house')}</label>
                            <input type="text" bind:value={settings.mapping.house} class="ltr">
                        </div>
                        <div class="input_con">
                            <label>{$_('settings.mapping_entrance')}</label>
                            <input type="text" bind:value={settings.mapping.entrance} class="ltr">
                        </div>
                    </div>
                    <div class="input_box">
                        <div class="input_con">
                            <label>{$_('settings.mapping_floor')}</label>
                            <input type="text" bind:value={settings.mapping.floor} class="ltr">
                        </div>
                        <div class="input_con">
                            <label>{$_('settings.mapping_apartment')}</label>
                            <input type="text" bind:value={settings.mapping.apartment} class="ltr">
                        </div>
                        <div class="input_con">
                            <label>{$_('settings.mapping_door')}</label>
                            <input type="text" bind:value={settings.mapping.door} class="ltr">
                        </div>
                    </div>
                    <div class="input_box">
                        <div class="input_con">
                            <label>{$_('settings.mapping_comments')}</label>
                            <input type="text" bind:value={settings.mapping.comments} class="ltr">
                        </div>
                    </div>


                    {/if}

       
                </div> 
            </div> 
  
            <div class="shipment-flex-button fixed bottom-[20px] z-20 left-0 right-0 m-auto">
                <div class="create_button" on:click={ handleSubmit }>{$_('settings.save')}</div>
            </div> 
        </div>
        
    </div>
</div>

